<template>
  <div
    class="mb-4 md:mb-6 flex flex-wrap items-center justify-between gap-4 w-full sm:flex-nowrap"
    :class="!$slots.actions && 'lg:min-h-12'"
  >
    <div class="flex flex-col justify-center">
      <span
       v-if="$slots.subtitle"
        class="font-sans text-slate-400"
      >
        <slot name="subtitle" />
      </span>

      <component
        :is="props.as ?? headingLevel"
        v-if="$slots.default"
        class="text-2xl xl:text-3xl font-sans font-extrabold leading-9 m-0 flex items-center"
      >
        <slot />
      </component>
    </div>
  <div class="flex grow justify-end items-center gap-2">
      <slot name="actions" />
  </div>
</div>
</template>
<script setup lang="ts">
import { inject } from 'vue';
import { PAGE_HEADING_LEVEL, type PageHeadingLevel } from '~/provides/pageHeadingLevel';

const props = defineProps<{ as?: PageHeadingLevel }>();

const headingLevel = inject(PAGE_HEADING_LEVEL, 'h1');
</script>
